export class TreatGenModel {
    Seq: number
    intClinicNo: number
    Frequency: string | null

    constructor(
        Seq: number,
        intClinicNo: number,
        Frequency: string | null = null
    ) {
        this.Seq = Seq
        this.intClinicNo = intClinicNo
        this.Frequency = Frequency
    }
}
